import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[ContractType SetFilter] Action',
  ResetFilter: '[ContractType ResetFilter] Action',
}

const initialContractTypeState: IContractTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IContractTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-ContractType', whitelist: ['filter']},
  (
    state: IContractTypeState = initialContractTypeState,
    action: ActionWithPayload<IContractTypeState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialContractTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
